{
  "addressForm": {
    "actions": {
      "cancel": "Cancel",
      "create": "Create address",
      "saveChanges": "Save changes",
      "saving": "Saving…"
    },
    "dialog": {
      "createSubtitle": "Enter the address details. You can assign it to a store after creating it.",
      "createTitle": "Add billing address",
      "editSubtitle": "Note: changes only apply to invoices generated afterward. Existing invoices keep their snapshot.",
      "editTitle": "Edit billing address"
    },
    "errors": {
      "createFailed": "Failed to create the address (HTTP {{status}}).",
      "loadFailed": "Failed to load the address (HTTP {{status}}).",
      "noData": "The response contains no address data.",
      "staleRecord": "This record was updated elsewhere. Reopen the address to get the latest data.",
      "unknown": "Unknown error. Please try again.",
      "updateFailed": "Update failed (HTTP {{status}})."
    },
    "fields": {
      "address": "Address *",
      "businessName": "Business name",
      "city": "City",
      "country": "Country (ISO 2 letters)",
      "email": "Email *",
      "name": "Recipient name *",
      "phone": "Phone",
      "state": "State/Province",
      "taxId": "Tax ID",
      "zip": "Postal code"
    },
    "loading": "Loading address…",
    "placeholders": {
      "address": "123 Le Loi Street, District 1",
      "country": "VN, US, JP…"
    },
    "toast": {
      "createFailedTitle": "Failed to create address",
      "createdDesc": "You can assign this address to a store from the list.",
      "createdTitle": "Billing address added",
      "updateFailedTitle": "Update failed",
      "updatedDesc": "Changes only apply to new invoices — existing invoices are unchanged.",
      "updatedTitle": "Address updated"
    },
    "validation": {
      "addressMax": "Address ≤ 500 characters.",
      "addressRequired": "Address is required.",
      "businessNameMax": "Business name ≤ 200 characters.",
      "cityMax": "City ≤ 100 characters.",
      "countryInvalid": "Country must be a 2-letter uppercase ISO code (e.g. VN, US).",
      "emailInvalid": "Invalid email.",
      "emailMax": "Email ≤ 254 characters.",
      "emailRequired": "Email is required.",
      "nameMax": "Name ≤ 200 characters.",
      "nameRequired": "Recipient name is required.",
      "phoneMax": "Phone ≤ 30 characters.",
      "stateMax": "State/Province ≤ 100 characters.",
      "taxIdMax": "Tax ID ≤ 50 characters.",
      "zipMax": "Postal code ≤ 20 characters."
    }
  },
  "addresses": {
    "actions": {
      "assignStores": "Assign stores",
      "cancel": "Cancel",
      "create": "+ Add address",
      "delete": "Delete",
      "edit": "Edit",
      "retry": "Retry"
    },
    "confirmDelete": {
      "deleting": "Deleting…",
      "description": "Delete \"{{name}}\"? If it is assigned to a store, the system will block it (HTTP 409). Existing invoices keep their snapshot — they are not affected.",
      "title": "Delete billing address?"
    },
    "empty": {
      "createButton": "+ Add your first address",
      "description": "Add your first address to print on invoices. You can create multiple addresses and assign them to individual stores.",
      "title": "No billing addresses yet"
    },
    "errors": {
      "deleteAssigned": "Cannot delete: the address is assigned to one or more stores.",
      "deleteFailed": "Delete failed (HTTP {{status}}).",
      "listFailed": "Failed to load the list (HTTP {{status}}).",
      "listGeneric": "Error loading the list.",
      "loadAddressFailed": "Failed to load the address (HTTP {{status}}).",
      "unknown": "Unknown error. Please try again."
    },
    "header": {
      "subtitle": "Manage the addresses printed on invoices. One address can be assigned to multiple stores; unassigned stores use the default address.",
      "title": "Billing addresses"
    },
    "pagination": {
      "first": "First page",
      "last": "Last page",
      "navLabel": "Pagination",
      "next": "Next page",
      "pageN": "Page {{page}}",
      "prev": "Previous page",
      "summary": "Showing {{from}}–{{to}} of {{total}} records · Page {{page}} / {{totalPages}}"
    },
    "sort": {
      "country": "By country",
      "newest": "Newest",
      "oldest": "Oldest"
    },
    "table": {
      "actions": "Actions",
      "address": "Address",
      "assignedStores": "Assigned stores",
      "business": "Business",
      "cannotDeleteDefault": "Cannot delete the default address",
      "default": "Default",
      "defaultBadge": "Default",
      "recipient": "Recipient",
      "taxId": "Tax ID: {{taxId}}"
    },
    "toast": {
      "deleteFailedTitle": "Delete failed",
      "deletedTitle": "Billing address deleted"
    },
    "toolbar": {
      "sortLabel": "Sort"
    }
  },
  "alerts": {
    "card": {
      "description": "The system sends an alert when your wallet balance drops below the threshold. The same threshold value is used for auto-recharge (Task 20). The in-app channel (bell + Notification Center) is always on per policy P3.D-11.",
      "title": "Low-Balance Alert"
    },
    "channelLabels": {
      "email": "Email",
      "inApp": "In-app",
      "inAppForced": "In-app (forced)",
      "push": "Push"
    },
    "channels": {
      "emailHint": "Send the alert to the owner account's registered email. On by default.",
      "emailTitle": "Email",
      "forcedWarning": "Note: even if all 3 channels are off, in-app is still sent (forced server-side).",
      "inAppHint": "In-app is always on (mandatory per policy P3.D-11) — it cannot be turned off.",
      "inAppTitle": "In-app (bell + Notification Center)",
      "legend": "Notification channels",
      "pushHint": "Requires browser notification permission. On by default.",
      "pushTitle": "Push (browser push notification)"
    },
    "errors": {
      "saveFailed": "Failed to save alert settings.",
      "saveFailedRetry": "Could not save alert settings. Please try again.",
      "testFailed": "Failed to send test alert.",
      "testRateLimited": "Test alert sent too quickly. Please wait 1 minute and try again.",
      "testSuspended": "Account is suspended. Cannot send test alert.",
      "testThresholdNotConfigured": "Configure a balance threshold (threshold > 0) before sending a test alert."
    },
    "form": {
      "saveButton": "Save settings",
      "saving": "Saving…",
      "sendTestButton": "Send test alert (1 / minute)",
      "sendingTest": "Sending…",
      "testDisabledHint": "Configure a balance threshold before sending a test alert.",
      "thresholdHelp": "When the balance crosses below the threshold (downward) → one alert is sent. When it is topped up above and drops again → another alert is sent. Leave empty = use the system default threshold ({{state}}).",
      "thresholdLabel": "Alert threshold (USD)",
      "thresholdPlaceholderEnvDefault": "Using system default",
      "thresholdPlaceholderExample": "e.g. 50",
      "thresholdStateApplying": "currently applied",
      "thresholdStateOverride": "will be overridden"
    },
    "suspended": {
      "readOnlyNotice": "Account is suspended. All settings are read-only."
    },
    "toast": {
      "rateLimitedTitle": "Rate limit exceeded (1/minute)",
      "saveFailedTitle": "Save failed",
      "savedDesc": "Balance alert settings have been updated.",
      "savedTitle": "Saved",
      "testFailedTitle": "Failed to send test alert",
      "testSentDesc": "Channels sent: {{channels}}.",
      "testSentTitle": "Test alert sent"
    },
    "validation": {
      "thresholdNonNegative": "The alert threshold (minimum balance) must be a non-negative number."
    }
  },
  "assignStores": {
    "assigned": {
      "empty": "No stores yet — unassigned stores fall back to the default address.",
      "heading": "Currently assigned stores ({{count}})"
    },
    "buttons": {
      "cancel": "Cancel",
      "submit": "Assign {{count}} stores",
      "submitting": "Assigning…"
    },
    "counts": {
      "invalid": "Invalid: {{count}}",
      "max": "Max: 50",
      "valid": "Valid: {{count}}"
    },
    "errors": {
      "assignFailedHttp": "Failed to assign stores (HTTP {{status}}).",
      "invalidIds": "{{count}} invalid ID(s). An ID must be a UUID or 24-char hex (ObjectId).",
      "maxFifty": "You can assign at most 50 stores at once.",
      "minOne": "Please enter at least 1 valid store ID.",
      "noAddress": "Billing address not found.",
      "unknown": "Unknown error. Please try again."
    },
    "fallbackNote": "Stores that are left out fall back to the default address.",
    "input": {
      "label": "Store IDs (UUID or 24-char hex, one ID per line or separated by commas)"
    },
    "replaceNote": "Submitting will replace the entire assignment for this address (replace semantics).",
    "subtitle": {
      "default": "Choose the stores that will use this address on invoices.",
      "withLabel": "Address: {{label}}"
    },
    "title": "Assign stores to billing address",
    "toast": {
      "errorTitle": "Failed to assign stores",
      "successDescription": "The stores are now assigned to this billing address.",
      "successTitle": "Assignment updated"
    }
  },
  "autoPay": {
    "card": {
      "description": "Configure automatic wallet deductions when an order is created. Applies to orders, surcharges (surcharge — extra charges added by an admin), stitch digitizing fees (digitize fee), and embroidery fees (embroidery fee). When off, the order is still created in an unpaid state and you must pay manually.",
      "title": "Automatic payment (auto-pay)"
    },
    "errors": {
      "network": "A network error occurred (network error — check your connection).",
      "persistence": "The save was not confirmed by the server (persistence check failed — check for ghost-save). Please try again.",
      "suspended": "Your account is suspended — automatic payment (auto-pay) configuration cannot be updated."
    },
    "loadError": {
      "generic": "unknown error",
      "label": "Could not load the current configuration: {{message}}"
    },
    "master": {
      "help": "When enabled, the system automatically deducts funds from the source selected below as soon as an order is created. Orders with insufficient funds move to pending_payment and are retried automatically (auto retry) when the wallet has more funds.",
      "label": "Enable automatic payment"
    },
    "mode": {
      "legend": "Funding source",
      "rule": "Rule: one source must cover the ENTIRE order — the system does not split payments (no split payment). Example: an order of {{order}}, wallet {{wallet}} + credit {{credit}} → the order stays unpaid because no single source is enough on its own.",
      "walletOnly": {
        "hint": "Deduct from the wallet only. If the wallet is insufficient → the order stays unpaid.",
        "label": "Wallet only"
      },
      "walletPlusCredit": {
        "hint": "Try the wallet first; if the wallet cannot cover the ENTIRE order, the system tries to deduct from credit — still following the one-source-covers-all rule.",
        "label": "Wallet + Credit"
      }
    },
    "notify": {
      "email": "Email",
      "help": "Turn this off if you process many orders and want to avoid notification spam. The system can still batch multiple orders into a single notification (notification batch) when needed.",
      "inApp": "In-app (notification bell in the TopBar)",
      "legend": "Notify when auto-pay succeeds"
    },
    "submit": {
      "loading": "Loading…",
      "save": "Save configuration",
      "saving": "Saving…",
      "suspendedTitle": "Account suspended — cannot save"
    },
    "success": "Automatic payment configuration saved.",
    "suspendedBanner": "Your account is suspended — view only, configuration cannot be edited."
  },
  "autoRecharge": {
    "actions": {
      "save": "Save settings",
      "saving": "Saving…"
    },
    "card": {
      "description": "Automatically add funds to your wallet when the balance drops below the trigger threshold (minimum balance). Applies to orders, surcharges, digitizing fees, and embroidery fees.",
      "title": "Auto-Recharge"
    },
    "disabledBanner": "The system automatically turned off auto-recharge after multiple consecutive failures. Check your payment method and re-enable it manually.",
    "fields": {
      "amountHelp": "Must be greater than or equal to the trigger threshold and at least {{min}}.",
      "amountLabel": "Amount per recharge (USD)",
      "amountPlaceholder": "Minimum {{min}}",
      "enabledLabel": "Enable auto-recharge",
      "maxPerDayHelp": "Configured by an administrator (admin). Exceeding the limit will automatically turn off auto-recharge and send a notification.",
      "maxPerDayLabel": "Daily auto-recharge limit",
      "maxPerDayValue": "{{limit}} times / day",
      "methodDefaultSuffix": " (default)",
      "methodLabel": "Payment method",
      "methodNone": "— None selected —",
      "thresholdHelp": "When your wallet balance drops below this level, the system triggers an auto-recharge. The same value is used for the low-balance alert.",
      "thresholdLabel": "Trigger threshold (USD)",
      "thresholdPlaceholder": "e.g. 50"
    },
    "noMethod": {
      "linkText": "Payment methods",
      "prefix": "No eligible payment method yet. Go to ",
      "suffix": " to link PayPal / Stripe / Payoneer / LianLian."
    },
    "toast": {
      "saveErrorDesc": "Could not save auto-recharge settings. Please try again.",
      "saveErrorTitle": "Save failed",
      "saveSuccessDesc": "Auto-recharge settings have been updated.",
      "saveSuccessTitle": "Saved"
    },
    "toggle": {
      "disabledHint": "Off — you must top up manually when the balance is low.",
      "enabledHint": "Enabled — the system will recharge automatically when the balance drops below the threshold.",
      "needMethodTooltip": "You must link a payment method that supports server-to-server charging (PayPal / Stripe / Payoneer / LianLian) before enabling auto-recharge."
    },
    "validation": {
      "amountGteThreshold": "The recharge amount (USD added each time) must be greater than or equal to the trigger threshold.",
      "amountMin": "The recharge amount must be at least {{min}} (system minimum).",
      "needLinkedMethod": "You must link a payment method (a verified gateway account) before enabling auto-recharge.",
      "selectMethod": "Please select a payment method for auto-recharge.",
      "thresholdPositive": "The trigger threshold (minimum balance) must be greater than 0."
    }
  },
  "billingLayout": {
    "actions": {
      "generateReport": "Generate Report",
      "generateReportAria": "Generate billing report",
      "topUp": "+ Top Up Wallet",
      "topUpAria": "Top up wallet"
    },
    "header": {
      "subtitle": "Manage invoices, top-ups, and fulfillment reports",
      "title": "Billing Overview"
    },
    "kpi": {
      "autoTopup": {
        "label": "Auto-topup Status",
        "off": "Off",
        "offHint": "Off — enable to auto-recharge",
        "on": "On",
        "onHint": "When balance < {{threshold}} → top up {{topup}}"
      },
      "balance": {
        "label": "Wallet Balance",
        "loading": "Loading wallet…",
        "pendingTopup": "Pending topup {{amount}}"
      },
      "pendingInvoices": {
        "label": "Pending Invoices",
        "subLabel": "{{amount}} pending payment"
      },
      "spending": {
        "label": "Spending This Month",
        "subLabel": "Last 30 days (MTD)"
      }
    },
    "settingsPlaceholder": {
      "suffix": ".",
      "text": "Billing settings (auto-pay, auto-recharge, low balance alert, invoice schedule, billing addresses, payment methods, 2FA) — Wave 6 Task 17/18. For now, access them separately at "
    },
    "tabs": {
      "ariaLabel": "Billing sections",
      "settings": "Settings",
      "transactions": "Transactions"
    },
    "transactionsPlaceholder": {
      "suffix": ".",
      "text": "Detailed transaction history — Wave 6 Task 17 (transactions table + filter chips + invoice action). For now, view the full wallet at "
    },
    "walletError": "Failed to load wallet ({{message}}).",
    "walletErrorUnknown": "unknown"
  },
  "billingPage": {
    "description": "Track credit and outstanding debt. Phase 3.5 will add wallet, transactions, and statements.",
    "title": "Billing (financial overview)"
  },
  "creditCard": {
    "daysValue": "{{count}}d",
    "debt": {
      "current": "Current debt: {{amount}}.",
      "none": "No outstanding debt to pay."
    },
    "fields": {
      "daysLeft": "Days left",
      "limit": "Limit",
      "remaining": "Remaining"
    },
    "payCta": "Pay debt",
    "status": {
      "active": "Active",
      "expired": "Expired",
      "overdue": "Overdue",
      "revoked": "Revoked"
    },
    "title": "Credit"
  },
  "invoiceDetail": {
    "actions": {
      "dispute": "Dispute",
      "downloadPdf": "Download PDF",
      "downloadPdfAria": "Download PDF",
      "downloading": "Downloading…",
      "pay": "Pay {{amount}}"
    },
    "bank": {
      "accountHolder": "Account holder",
      "accountNumber": "Account number",
      "accountType": "Account type",
      "bankAddress": "Bank address",
      "bankCode": "Bank code",
      "bankName": "Bank name",
      "branchCode": "Branch code",
      "heading": "Bank account",
      "subtitle": "Wire transfer details for {{name}}.",
      "swiftCode": "SWIFT code",
      "walletsHeading": "Other accepted wallets"
    },
    "detailError": {
      "backToInvoices": "Back to invoices",
      "loadFailed": "Failed to load invoice",
      "retry": "Retry"
    },
    "download": {
      "failedHttp": "Failed to download PDF (HTTP {{status}})",
      "failedTitle": "Download failed",
      "networkError": "Network error - check connection",
      "notReady": "Invoice still draft — PDF not yet rendered."
    },
    "gateway": {
      "airwallex": "Airwallex",
      "bank": "Bank transfer",
      "lianlian": "LianLian",
      "manual": "Manual",
      "payoneer": "Payoneer",
      "paypal": "PayPal",
      "pingpong": "PingPong",
      "stripe": "Stripe",
      "sunrate": "Sunrate",
      "worldfirst": "WorldFirst"
    },
    "header": {
      "backToInvoices": "Back to invoices",
      "cycleLabel": "{{start}} → {{end}} cycle",
      "netTerms": " · Net terms (due {{date}})",
      "title": "Invoice {{number}}"
    },
    "help": {
      "contactSupport": "Contact support",
      "heading": "Need help?",
      "question": "Questions about this invoice?"
    },
    "lineItems": {
      "colDescription": "Description",
      "colQty": "Qty",
      "colTotal": "Total",
      "colUnit": "Unit",
      "empty": "No line items.",
      "heading": "Line items",
      "subtotal": "Subtotal",
      "tax": "Tax",
      "totalDue": "Total Due"
    },
    "notFound": {
      "backToInvoices": "Back to invoices",
      "message": "Invoice not found."
    },
    "payDialog": {
      "ariaLabel": "Submit payment",
      "bodyAfter": "component (Task 47, Wave 15). This dialog hosts the test ID hook so the Pay flow is reachable while the canonical component is wired.",
      "bodyBefore": "The full payment submission form (gateway, amount, reference, proof upload, notes) is provided by the shared",
      "cancel": "Cancel",
      "close": "Close",
      "submit": "Continue to pay",
      "subtitle": "Invoice {{number}} · Remaining {{amount}}",
      "title": "Submit payment"
    },
    "payment": {
      "dueLabel": "Due:",
      "heading": "Payment",
      "paidLabel": "Paid:",
      "payNow": "Pay Now",
      "payNowAria": "Pay now"
    },
    "paymentStatus": {
      "APPROVED": "Approved",
      "PENDING_APPROVAL": "Pending approval",
      "REJECTED": "Rejected",
      "REVERSED": "Reversed"
    },
    "payments": {
      "colAmount": "Amount",
      "colGateway": "Gateway",
      "colReference": "Reference",
      "colStatus": "Status",
      "colSubmitted": "Submitted",
      "heading": "Payment history"
    },
    "preview": {
      "heading": "Invoice preview",
      "iframeTitle": "Invoice {{number}} preview",
      "subtitle": "Rendered from the latest PDF template."
    },
    "status": {
      "DRAFT": "Draft",
      "OVERDUE": "Overdue",
      "PAID": "Paid",
      "PARTIAL": "Partially paid",
      "PENDING_APPROVAL": "Pending approval",
      "SENT": "Awaiting payment",
      "VOIDED": "Voided"
    }
  },
  "invoiceList": {
    "errors": {
      "loadTitle": "Failed to load invoices",
      "unknown": "Unknown error"
    },
    "filters": {
      "dueBeforeAria": "Due before date",
      "searchAria": "Search invoices by number or month",
      "searchPlaceholder": "Invoice # or month…",
      "statusAria": "Filter by status"
    },
    "forbidden": {
      "backHome": "Back to home",
      "body": "The Invoices page is accessible only to the merchant owner. If you need to view invoices, please contact the owner to request a scope change or the appropriate permission (TS-34).",
      "title": "Owner only"
    },
    "header": {
      "subtitle": "Past and current billing cycles. Net-Terms invoices are issued automatically according to the cycle the merchant has configured.",
      "title": "My Invoices"
    },
    "pagination": {
      "next": "Next",
      "prev": "Previous",
      "summary": "Showing {{from}}–{{to}} of {{total}} invoices · Page {{page}} / {{totalPages}}"
    },
    "payDisabled": {
      "DRAFT": "Draft invoice",
      "PAID": "Already paid",
      "PENDING_APPROVAL": "Awaiting admin approval",
      "VOIDED": "Voided invoice",
      "default": "Cannot pay"
    },
    "payModal": {
      "ariaLabel": "Pay submission form",
      "bodyAfter": ".",
      "bodyBefore": "The detailed form (gateway / amount / proof_file / notes) is under development in Task 47 of the same wave (Wave 15). Once the sibling commits, this placeholder will be replaced by",
      "closeAria": "Close",
      "closeButton": "Close",
      "remaining": "{{amount}} remaining to pay.",
      "title": "Submit payment — {{number}}"
    },
    "statusBadge": {
      "DRAFT": "Draft",
      "OVERDUE": "Overdue",
      "PAID": "Paid",
      "PARTIAL": "Partial",
      "PENDING_APPROVAL": "Pending",
      "SENT": "Sent",
      "VOIDED": "Void"
    },
    "statusFilter": {
      "OVERDUE": "Overdue",
      "PAID": "Paid",
      "PARTIAL": "Partially paid",
      "PENDING_APPROVAL": "Pending approval",
      "SENT": "Sent",
      "all": "All"
    },
    "table": {
      "colActions": "Actions",
      "colAmount": "Amount",
      "colCycle": "Cycle",
      "colDue": "Due",
      "colInvoice": "Invoice #",
      "colStatus": "Status",
      "empty": "No invoices in the current scope yet.",
      "loading": "Loading invoices…",
      "pay": "Pay",
      "pdf": "PDF",
      "retry": "Try again"
    }
  },
  "invoices": {
    "detail": {
      "ariaLabel": "Invoice detail",
      "billingAddress": "Recipient (billing address)",
      "close": "Close",
      "colDescription": "Description",
      "colLineTotal": "Line total",
      "colQty": "Qty",
      "colUnitPrice": "Unit price",
      "downloadPdf": "Download PDF",
      "downloadingPdf": "Downloading…",
      "errorPrefix": "Failed to load detail: {{message}}",
      "grandTotal": "Total",
      "issuedAt": "Issued {{date}}",
      "legalEntity": "Issuer (legal entity)",
      "lineItems": "Line items",
      "loading": "Loading invoice detail…",
      "mst": "Tax ID: {{value}}",
      "noLines": "No line items.",
      "period": "Billing period",
      "retry": "Retry",
      "subtotal": "Subtotal",
      "taxId": "Tax ID: {{value}}",
      "titleFallback": "Invoice detail",
      "totals": "Totals"
    },
    "filters": {
      "dateFrom": "From date",
      "dateTo": "To date",
      "sort": "Sort",
      "sortOptions": {
        "newest": "Newest",
        "oldest": "Oldest",
        "totalAsc": "Total (low → high)"
      },
      "status": "Status",
      "statusAll": "All"
    },
    "list": {
      "empty": "No invoices yet — invoices are issued automatically by the Phase 4.1 cron (monthly cycle).",
      "errorPrefix": "Failed to load data: {{message}}",
      "loading": "Loading invoices…",
      "retry": "Retry"
    },
    "page": {
      "description": "List of invoices by period. Download the PDF for printing / archiving. Invoices are issued automatically by the Phase 4.1 cron.",
      "title": "Invoices"
    },
    "pagination": {
      "next": "Next",
      "prev": "Previous",
      "showing": "Showing {{from}}–{{to}} of {{total}} invoices · Page {{page}} / {{totalPages}}"
    },
    "status": {
      "cancelled": "Cancelled",
      "draft": "Draft",
      "issued": "Issued",
      "paid": "Paid"
    },
    "table": {
      "actions": "Actions",
      "issuedAt": "Issued date",
      "loadingPdf": "Downloading…",
      "number": "Invoice no.",
      "pdf": "PDF",
      "period": "Period",
      "status": "Status",
      "total": "Total",
      "view": "View"
    },
    "toast": {
      "pdfFailedTitle": "PDF download failed",
      "pdfPendingDesc": "The system is generating the PDF for this invoice. Please try again in about 30 seconds.",
      "pdfPendingTitle": "PDF is being generated",
      "pdfServerError": "Server error (HTTP {{status}})."
    }
  },
  "limitRequestHistory": {
    "cancel": "Cancel",
    "cancelToast": {
      "errorTitle": "Could not cancel request",
      "successDescription": "The request has been moved to Cancelled status.",
      "successTitle": "Request cancelled"
    },
    "columns": {
      "actions": "Actions",
      "amount": "Amount",
      "reason": "Reason",
      "requestedAt": "Requested at",
      "reviewNote": "Review note",
      "reviewedAt": "Reviewed at",
      "status": "Status"
    },
    "confirmCancel": {
      "confirmLabel": "Cancel request",
      "description": "This action cannot be undone. You can create a new request after cancelling.",
      "title": "Cancel request {{amount}}?"
    },
    "createFirst": "Create your first request",
    "empty": "No requests yet.",
    "heading": "Limit request history",
    "loadError": "Failed to load history: {{message}}",
    "loadMore": "Load more",
    "loading": "Loading request history…",
    "requestMore": "Request more",
    "retry": "Try again",
    "status": {
      "approved": "Approved",
      "cancelled": "Cancelled",
      "expired": "Expired",
      "pending": "Pending",
      "rejected": "Rejected"
    },
    "subheading": "Newest requests on top. Pending requests can be cancelled."
  },
  "limitRequestModal": {
    "actions": {
      "cancel": "Cancel",
      "submit": "Submit request",
      "submitting": "Submitting…"
    },
    "amount": {
      "hint": "Minimum $1.00 — enter in USD.",
      "label": "Amount to increase (USD)"
    },
    "duration": {
      "error": "Duration must be between 1 and 365 days.",
      "label": "Applicable duration (days, 1–365)"
    },
    "durationPreset": "{{days}}d",
    "errors": {
      "invalidAmount": "Invalid amount — minimum $1.00.",
      "invalidPayload": "Invalid payload",
      "payloadField": "payload",
      "pendingExists": "You already have a pending request — cancel the old one first (see the History section below).",
      "submitFallback": "Failed to submit request."
    },
    "reason": {
      "error": "Description must be at least {{min}} characters, at most {{max}}.",
      "hint": "Briefly explain why you need a higher limit.",
      "label": "Reason (minimum {{min}} characters)",
      "placeholder": "e.g. Need budget for the Tet campaign — approved by the leader via Slack."
    },
    "title": "Request a spending limit increase",
    "toast": {
      "error": {
        "title": "Failed to submit request"
      },
      "pending": {
        "description": "Cancel the old request first (see the History section below).",
        "title": "You already have a pending request"
      },
      "success": {
        "description": "The Team Lead will review it as soon as possible.",
        "title": "Request submitted"
      }
    }
  },
  "memberBilling": {
    "cards": {
      "remaining": {
        "label": "Remaining"
      },
      "total": {
        "label": "Total limit",
        "noLimit": "No limit granted",
        "periodSubLabel": "Period: {{period}}"
      },
      "usagePct": {
        "label": "% Used"
      },
      "used": {
        "label": "Used"
      }
    },
    "emptyBanner": {
      "cta": "Request more",
      "description": "Request more limit to keep paying for orders.",
      "title": "You've used up this period's limit"
    },
    "error": {
      "message": "Failed to load limit: {{message}}",
      "retry": "Retry"
    },
    "header": {
      "description": "Track your allotted limit, how much you've spent, and request more when needed.",
      "title": "Limit & Spending"
    },
    "loading": "Loading limit…",
    "overview": {
      "requestMore": "Request more limit",
      "title": "This period overview"
    },
    "period": {
      "biweekly": "Bi-weekly",
      "daily": "Daily",
      "monthly": "Monthly",
      "quarter": "Quarter",
      "weekly": "Weekly"
    },
    "periodTabs": {
      "ariaLabel": "Select limit period"
    },
    "transactions": {
      "placeholder": "Available once Phase 3.5 completes the member-side ledger.",
      "title": "Transaction history"
    }
  },
  "merchantPay": {
    "actions": {
      "cancel": "Cancel",
      "submit": "Submit Payment",
      "submitting": "Submitting…",
      "uploading": "Uploading proof…"
    },
    "amount": {
      "hint": "Full amount: {{amount}} · Partial allowed: yes",
      "label": "Amount (USD)"
    },
    "errors": {
      "amountExceedsFallback": "Amount exceeds remaining balance.",
      "amountInvalidDecimals": "Amount must be a positive USD value with up to 2 decimals.",
      "gatewayNotEnabled": "Selected gateway not enabled for this entity.",
      "proofRequired": "Proof required",
      "referenceAlreadyUsed": "Reference already used",
      "submitFailedHttp": "Submit failed (HTTP {{status}}).",
      "submitFailedTitle": "Submit failed",
      "unexpected": "Unexpected error."
    },
    "file": {
      "mimeReject": "PDF, PNG, JPG only.",
      "sizeReject": "Max 5MB."
    },
    "gateway": {
      "label": "Payment Gateway",
      "placeholder": "Select a gateway…"
    },
    "idempotencyNotice": "This action submits payment proof for accounting review. Submitting twice within 30s will be deduplicated by Idempotency-Key.",
    "noMethods": "No payment gateways are enabled for this legal entity. Contact support to configure one before submitting payment.",
    "notes": {
      "label": "Notes (optional)",
      "placeholder": "Bank wire executed by accounting — please verify"
    },
    "proof": {
      "browse": "browse",
      "constraints": "Max 5MB · PDF, PNG, JPG only",
      "dropInstruction": "Drop bank receipt PDF/PNG here, or",
      "label": "Proof of payment",
      "replace": "Replace file"
    },
    "reference": {
      "placeholder": "WIRE-OUT-20260430-MRCH-7"
    },
    "referenceLabel": {
      "airwallex": "Airwallex transaction ID",
      "bank": "SWIFT reference",
      "default": "Payment reference",
      "lianlian": "LianLian transfer ID",
      "payoneer": "Payoneer transaction ID",
      "paypal": "PayPal transaction ID",
      "pingpong": "PingPong transfer ID",
      "stripe": "Stripe charge ID",
      "sunrate": "SunRate transfer ID",
      "worldfirst": "WorldFirst transfer ID"
    },
    "subtitle": "Pay invoice {{invoiceNumber}} — {{amount}}",
    "success": {
      "description": "Awaiting accounting approval — invoice now Pending Approval.",
      "title": "Payment submitted"
    },
    "title": "Submit Payment",
    "upload": {
      "failed": "Proof upload failed.",
      "failedHttp": "Upload failed (HTTP {{status}})",
      "networkError": "Network error during upload.",
      "noUrl": "Upload service returned no URL — please retry or contact support."
    },
    "validation": {
      "amountExceeds": "Amount exceeds remaining balance ({{amount}}).",
      "amountInvalid": "Amount must be a positive USD value (max 2 decimals).",
      "gatewayRequired": "Select a payment gateway.",
      "notesTooLong": "Notes ≤ 500 characters.",
      "proofRequired": "Proof required",
      "referenceRequired": "Reference required.",
      "referenceTooLong": "Reference ≤ 120 characters."
    }
  },
  "outstandingWidget": {
    "aria": {
      "due": "due {{date}}",
      "outstanding": "Outstanding {{amount}}"
    },
    "due": {
      "label": "Due {{date}}"
    },
    "relativeDays": {
      "inDays": "in {{count}} days",
      "overdueDays": "{{count}} days overdue",
      "overdueOneDay": "1 day overdue",
      "today": "today",
      "tomorrow": "tomorrow"
    }
  },
  "overdueBanner": {
    "dismissAria": "Dismiss notification",
    "many": {
      "after": "). Please pay to keep placing orders.",
      "before": "You have ",
      "middle": " overdue invoices (the oldest is due on "
    },
    "one": {
      "after": "). Please pay to keep placing orders.",
      "before": "You have 1 overdue invoice (due on "
    },
    "viewInvoices": "View invoices"
  },
  "payCredit": {
    "actions": {
      "cancel": "Cancel",
      "submit": "Confirm payment",
      "submitting": "Processing…"
    },
    "amountHint": "Minimum $1.00 — maximum {{max}}.",
    "amountLabel": "Amount ($)",
    "currentDebt": "Current debt",
    "errors": {
      "invalidAmount": "Invalid amount.",
      "overdueLocked": "Credit is locked due to overdue — debt {{debt}} (due {{dueDate}}). Contact admin to unlock.",
      "unknown": "Unknown error.",
      "walletInsufficient": "Insufficient wallet — the balance has changed. Please reload the page and try again."
    },
    "insufficientNotice": "Insufficient wallet — you can pay at most",
    "payFull": "Pay Full",
    "title": "Pay off Credit",
    "toast": {
      "successDescription": "Paid {{amount}} — your new balance has been updated.",
      "successTitle": "Credit paid"
    },
    "topupCta": "Add funds",
    "walletBalance": "Wallet balance"
  },
  "paymentRequests": {
    "create": {
      "amount": "Amount",
      "ariaLabel": "Create payment request",
      "cancel": "Cancel",
      "charCount": "{{count}}/{{max}} characters",
      "description": "Request an off-platform refund or credit from Printway. Admins will review within 1–2 business days.",
      "purpose": "Purpose",
      "purposePlaceholder": "Describe the reason for your request in detail (min 10 characters, max 500)…",
      "submit": "Create request",
      "submitting": "Submitting…",
      "title": "Create a new payment request"
    },
    "createButton": "+ Create request",
    "detail": {
      "adminDecided": "Admin processed — {{status}}",
      "amount": "Amount",
      "ariaLabel": "Payment request detail",
      "awaitingAdmin": "Awaiting admin processing…",
      "close": "Close",
      "createdAt": "Created {{date}}",
      "history": "Status history",
      "purpose": "Purpose",
      "submitted": "Request submitted"
    },
    "filters": {
      "sort": "Sort",
      "sortOptions": {
        "newest": "Newest",
        "oldest": "Oldest",
        "status": "By status"
      },
      "status": "Status",
      "statusAll": "All"
    },
    "list": {
      "empty": "No payment requests yet — click + Create request to get started.",
      "errorPrefix": "Failed to load data: {{message}}",
      "loading": "Loading payment requests…",
      "retry": "Retry"
    },
    "page": {
      "description": "Off-platform refund / credit requests from Printway. Admins process them manually or automatically (by rule).",
      "title": "Payment Requests"
    },
    "pagination": {
      "next": "Next",
      "prev": "Previous",
      "showing": "Showing {{from}}–{{to}} of {{total}} requests · Page {{page}} / {{totalPages}}"
    },
    "status": {
      "approved": "Approved",
      "cancelled": "Cancelled",
      "paid": "Paid",
      "pending": "Pending",
      "rejected": "Rejected"
    },
    "table": {
      "actions": "Actions",
      "amount": "Amount",
      "decidedAt": "Processed date",
      "number": "Request no.",
      "requestedAt": "Created date",
      "status": "Status",
      "view": "View"
    },
    "toast": {
      "amountInvalidDesc": "Please enter a positive number.",
      "amountInvalidTitle": "Invalid amount",
      "createFailedTitle": "Failed to create request",
      "createdDesc": "Request number: {{number}}",
      "createdTitle": "Request created",
      "purposeShortDesc": "Please provide details (at least 10 characters).",
      "purposeShortTitle": "Purpose too short"
    }
  },
  "receipts": {
    "deliveryStatus": {
      "failed": "Failed",
      "pending": "Pending",
      "sent": "Sent",
      "skipped": "Skipped"
    },
    "download": {
      "aria": "Download receipt {{receiptNumber}}",
      "button": "Download",
      "failedFallback": "Could not download {{receiptNumber}}.",
      "failedTitle": "Download failed"
    },
    "errors": {
      "loadFailed": "Failed to load receipts."
    },
    "filters": {
      "dateFrom": {
        "aria": "Filter receipts issued on or after this date",
        "label": "From"
      },
      "dateTo": {
        "aria": "Filter receipts issued on or before this date",
        "label": "To"
      },
      "delivery": {
        "all": "All deliveries",
        "aria": "Filter receipts by email delivery status",
        "label": "Delivery"
      },
      "direction": {
        "aria": "Receipt sort direction",
        "asc": "Ascending (oldest / smallest first)",
        "desc": "Descending (newest / largest first)",
        "label": "Direction"
      },
      "sort": {
        "aria": "Receipt sort field",
        "label": "Sort by"
      },
      "source": {
        "all": "All sources",
        "aria": "Filter receipts by topup source",
        "label": "Source"
      }
    },
    "header": {
      "description": "One PDF receipt per successful topup — automatic for instant gateways (Tier 1) and after admin approval for manual topups (Tier 2). Receipts are tax records retained for 7 years.",
      "title": "Topup Receipts"
    },
    "pagination": {
      "next": "Next",
      "nextAria": "Next page of receipts",
      "prev": "Previous",
      "prevAria": "Previous page of receipts",
      "summary": "Page {{page}} of {{totalPages}} — {{total}} receipts"
    },
    "sortField": {
      "amount": "Amount",
      "issued_at": "Issued at",
      "receipt_number": "Receipt number"
    },
    "sourceType": {
      "TOPUP_TIER1": "Tier 1 (Auto)",
      "TOPUP_TIER2": "Tier 2 (Manual)"
    },
    "states": {
      "emptyBody": "Receipts appear here after a successful topup. Try widening the filters above.",
      "emptyTitle": "No receipts yet",
      "loading": "Loading receipts…"
    },
    "table": {
      "action": "Action",
      "amount": "Amount",
      "delivery": "Delivery",
      "issued": "Issued",
      "receiptNumber": "Receipt #",
      "source": "Source"
    }
  },
  "settingsTabs": {
    "alertHistory": {
      "allChannels": "All channels",
      "allStatuses": "All statuses",
      "firstPageAria": "First page",
      "lastPageAria": "Last page",
      "nextPageAria": "Next page",
      "prevPageAria": "Previous page"
    },
    "alerts": {
      "channelEmail": "Email notifications",
      "channelPush": "Push notifications",
      "thresholdSliderAria": "Alert threshold slider",
      "title": "Low Balance Alerts",
      "subtitle": "Get notified when your wallet balance falls below a threshold",
      "thresholdLabel": "Alert Threshold",
      "thresholdHelp": "You'll be notified when your balance falls below this amount",
      "thresholdPlaceholder": "50",
      "channelsLegend": "Notification Channels",
      "channelsHelp": "Choose how you want to receive alerts",
      "channelInApp": "In-app notifications (always on)",
      "emailRecipientsLabel": "Email recipients (comma-separated, max 10)",
      "emailRecipientsPlaceholder": "owner@example.com, finance@example.com",
      "smsRecipientsLabel": "SMS recipients (E.164, max 5)",
      "smsRecipientsPlaceholder": "+1415..., +84...",
      "cooldownLabel": "Cooldown (hours, 1-168)",
      "testTitle": "Test Alert",
      "testHelp": "Send a test alert to verify your settings are working",
      "sendTest": "Send Test Alert",
      "savedDesc": "Alert settings updated.",
      "errThreshold": "Threshold must be a non-negative number.",
      "errEmailInvalid": "Invalid email address: {{value}}",
      "errEmailMax": "Maximum 10 email recipients allowed.",
      "errSmsInvalid": "Invalid E.164 phone number: {{value}}",
      "errSmsMax": "Maximum 5 SMS recipients allowed.",
      "errCooldown": "Cooldown must be between 1 and 168 hours.",
      "testDispatchedTitle": "Test alert dispatched",
      "testDispatchedDesc": "{{ok}}/{{total}} channel(s) queued for delivery.",
      "rateLimitTitle": "Rate limit reached",
      "noChannelsTitle": "No channels configured",
      "testFailedTitle": "Test alert failed",
      "clientRateLimit": "Please wait a moment before sending another test alert."
    },
    "autoTopup": {
      "pmPlaceholder": "Payment method UUID",
      "title": "Auto Top-up",
      "subtitle": "Automatically top up your wallet when balance falls below a trigger threshold.",
      "triggerLabel": "Trigger threshold (charge when balance falls below)",
      "triggerPlaceholder": "50.00",
      "amountLabel": "Top-up amount (charge this each time)",
      "amountPlaceholder": "500.00",
      "dailyLabel": "Daily limit (optional)",
      "dailyPlaceholder": "1000.00",
      "monthlyLabel": "Monthly limit (optional)",
      "monthlyPlaceholder": "5000.00",
      "pmLabel": "Payment method (linked account)",
      "pmSelectEmpty": "— Select a verified payment method —",
      "pmUnverified": "(unverified)",
      "pmManageHelp": "Manage linked accounts at {{path}}.",
      "errTrigger": "Trigger threshold must be a non-negative number.",
      "errAmountPositive": "Top-up amount must be greater than 0.",
      "errAmountDaily": "Top-up amount must be ≤ daily limit.",
      "errDailyMonthly": "Daily limit must be ≤ monthly limit.",
      "errPmRequired": "Choose a payment method to enable auto top-up.",
      "errLimitExceeded": "Top-up amount exceeds the configured daily limit.",
      "errPmNotVerified": "Payment method must be verified before enabling auto top-up.",
      "errPmNotFound": "Payment method not found.",
      "concurrentTitle": "Concurrent edit detected",
      "concurrentDesc": "Settings were modified elsewhere. Reloading the latest values…",
      "savedDesc": "Auto top-up settings updated."
    },
    "nav": {
      "breadcrumbAria": "Breadcrumb",
      "sectionsAria": "Billing settings sections",
      "crumbBilling": "Billing",
      "crumbSettings": "Settings"
    },
    "taxDocs": {
      "filterByYearAria": "Filter tax documents by year"
    },
    "page": {
      "title": "Billing Settings",
      "subtitle": "Configure wallet alerts, auto top-up, and notification preferences"
    },
    "loading": "Loading…",
    "tabs": {
      "alerts": "Alert Settings",
      "autoTopup": "Auto Top-up",
      "history": "Alert History",
      "receipts": "Receipts",
      "tax": "Tax Documents"
    },
    "common": {
      "enabled": "Enabled",
      "disabled": "Disabled",
      "save": "Save changes",
      "saving": "Saving…",
      "sending": "Sending…",
      "savedTitle": "Saved",
      "saveFailedTitle": "Save failed",
      "networkError": "Network error — check connection"
    }
  },
  "spendingChart": {
    "ariaLabel": "Stacked bar chart showing spending over the last {{window}} days",
    "empty": "No spending data yet.",
    "emptyWindow": "No spending data in the last {{window}} days",
    "error": "Failed to load transactions ({{message}}).",
    "footer": {
      "label": "Total spending (outflow) over {{window}} days:"
    },
    "loading": "Loading spending data…",
    "series": {
      "embroidery": "Embroidery",
      "order": "Order",
      "surcharge": "Surcharge",
      "topup": "Topup",
      "withdraw": "Withdraw"
    },
    "title": "Spending (last {{window}} days)",
    "tooltip": {
      "total": "{{day}} — Total {{amount}}"
    },
    "unknownError": "unknown"
  },
  "history": {
    "allChannels": "All channels",
    "allStatuses": "All statuses",
    "from": "From",
    "to": "To",
    "channel": "Channel",
    "status": "Status",
    "chanEmail": "Email",
    "chanSms": "SMS",
    "chanPush": "Push",
    "chanInapp": "In-app",
    "statusSent": "Sent",
    "statusFailed": "Failed",
    "statusBounced": "Bounced",
    "statusPending": "Pending",
    "apply": "Apply filters",
    "reset": "Reset",
    "exportCsv": "Export CSV",
    "exporting": "Exporting…",
    "colDate": "Date",
    "colChannel": "Channel",
    "colRecipient": "Recipient",
    "colThreshold": "Threshold",
    "colBalance": "Balance",
    "colStatus": "Status",
    "loading": "Loading alert history…",
    "error": "Failed to load alert history.",
    "empty": "No alerts in the selected range.",
    "showing": "Showing {{start}}-{{end}} of {{total}} records",
    "pageOf": "Page {{page}} of {{total}}",
    "firstPageAria": "First page",
    "prevPageAria": "Previous page",
    "nextPageAria": "Next page",
    "lastPageAria": "Last page",
    "exportOkTitle": "Export ready",
    "exportOkBody": "Your CSV download is starting.",
    "exportFailTitle": "Export failed",
    "exportFailBody": "Could not export the alert history. Try narrowing the filters."
  },
  "tax": {
    "filterByYearAria": "Filter tax documents by year",
    "title": "Monthly Tax Document Bundles",
    "subtitle": "Download monthly tax bundles (CSV inside ZIP) for your records.",
    "year": "Year",
    "colPeriod": "Period",
    "colEntity": "Legal Entity",
    "colStatus": "Status",
    "colFiles": "Files",
    "colSize": "Size",
    "colGenerated": "Generated",
    "colAction": "Action",
    "loading": "Loading tax documents…",
    "error": "Failed to load tax documents.",
    "emptyTitle": "No tax documents yet",
    "emptyBody": "Monthly tax bundles for {{year}} will appear here once generated.",
    "download": "Download",
    "preparing": "Preparing…",
    "statusReady": "Ready",
    "statusFailed": "Failed",
    "statusGenerating": "Generating",
    "statusPending": "Pending",
    "downloadAria": "Download tax bundle for {{period}}",
    "disclaimer": "These documents are provided for your accounting and tax filing purposes. Printway does not provide tax advice. Please consult a qualified tax advisor in your jurisdiction.",
    "toastStartedTitle": "Download started",
    "toastStartedBody": "{{period}} bundle ({{size}})",
    "toastFailTitle": "Download failed",
    "toastNotReadyTitle": "Bundle still generating",
    "toastFailBody": "Could not download the {{period}} bundle — try again later."
  }
}
